import React from "react";
import { AddAdvisorContainer } from "../../../containers";

const AddAdvisor = (props) => {
  return <AddAdvisorContainer {...props} />;
};

export default AddAdvisor;
